import React, { FC } from 'react';
import styled from 'styled-components';

import { toggleSubscription } from '~/atomic/page/author/author.data';
import { authorSelector } from '~/atomic/page/author/author.selector';
import { TextBoldStyle, TextRegStyle } from '~/atomic/Typography';
import { SubscriptionButton } from '~/feature/subscriptions/SubscriptionButton';
import { userSelector } from '~/feature/user/user.selector';
import { lessThan } from '~/lib/mediaQuery';
import { useAppDispatch, useAppSelector } from '~/store';

export const EmptySubscribersPage: FC = () => {
  const dispatch = useAppDispatch();

  const { user } = useAppSelector(userSelector);

  const {
    currentAuthor,
    subscriptionLoading,
    isSubscription,
  } = useAppSelector(authorSelector);

  const subscribeClickHandler = () => {
    dispatch(toggleSubscription({ authorUsername: currentAuthor.username }));
  };

  return (
    <SCEmptySubscribersPage>
      <SCImage
        src="/icon/gray-subscribers.svg"
        alt="Пара обезличенных персонажей"
      />
      <SCTitle>
        Только вас и ждали!
      </SCTitle>
      <SCMessage>
        У автора пока нет подписчиков. Выразите свою поддержку — станьте первым,
        кто следит за его творчеством и новостями
      </SCMessage>
      {(currentAuthor.id !== user.id) && (
        <SCSubscribeButtonWrapper>
          <SubscriptionButton
            isLoading={subscriptionLoading}
            isSubscription={isSubscription}
            onClickHandler={subscribeClickHandler}
            subscribeText="Подписаться на автора"
          />
        </SCSubscribeButtonWrapper>
      )}
    </SCEmptySubscribersPage>
  );
};

const SCSubscribeButtonWrapper = styled.div`
  max-width: 212px;
`;

const SCMessage = styled.span`
  ${TextRegStyle};
  margin-bottom: 18px;
  max-width: 514px;
  text-align: center;                
`;

const SCTitle = styled.span`
  ${TextBoldStyle};
  margin-bottom: 18px;
  color: var(--color-black);
`;

const SCImage = styled.img`
  width: 64px;
  height: 64px;
  margin-top: 51px;
  margin-bottom: 18px;
`;

const SCEmptySubscribersPage = styled.div`
  width: 100%;
  box-sizing: border-box;
  margin-left: 42px;
  height: 520px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: var(--white-color);
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  padding-left: 16px;
  padding-right: 16px;
  
  ${lessThan('sm')} {
    margin-top: 28px;
    margin-left: unset;
    height: 360px;
  }
  
`;
